import { Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ToastrService } from "ngx-toastr";
import * as CONSTANT from "../../services/constants";
import * as CryptoJS from "crypto-js";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { environment } from "src/environments/environment";
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from "@angular/common/http"
import { ImageUrls } from "../../services/s3buket";

@Component({
  selector: "app-upload-document",
  templateUrl: "./upload-document.component.html",
  styleUrls: ["./upload-document.component.css"]
})
export class UploadDocumentComponent implements OnInit {
  serviceList: any = [];
  modalRef?: BsModalRef;
  public form: FormGroup;
  showError: boolean = false;
  public loading = false;
  fileUpload;
  fileName: any;
  haveFileName: any;
  vetFileUpload;
  vetFileName: any;
  haveVeternFileName: any;
  userData: any;
  veteranRelationName:any;
  isAccept: boolean = false;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users
  fileSize: boolean = false;
  fileSizeVeteranRelation: boolean = false;
  showOtherService: boolean = false;
  // awards list
  awardList: any = [];
  actionUpload = "";
  // mos list
  allMosCode: any = [];
  dropdownSettingsMilitary:any;
  selectedServiceId:any;
  constructor(private modalService: BsModalService, private formBuilder: FormBuilder, public route: ActivatedRoute, private router: Router, private api: AdminService, private toastrService: ToastrService, private http: HttpClient, private handler: HttpBackend) {
    this.form = this.formBuilder.group({
      serviceId: ["", Validators.compose([Validators.required])],
      otherServiceTitle: [""],
      JobTitle: ["", Validators.compose([Validators.required])],
      militaryJobTitleId: [""],
      militaryJobTitle: [""],
      authenticityDocumentLink: [""],
      veteranRelationDocumentLink: [""],
      veteranRelationName: [""],
      userType: [""],
      honorAwardArray: [""],
      serviceDisabled: [""],
      isRequired: ["1", Validators.compose([Validators.required])],
    });
  }

  ngOnInit(): void {
    this.veteranRelationName = localStorage.getItem("veteranRelationName");
    this.getServices();
    this.getUserDetail();
    // this.getMosCode();
    this.dropdownSettingsMilitary = {
			singleSelection: true,
			idField: "id",
			textField: "fullName",
			itemsShowLimit: 1,
			allowSearchFilter: true,
      unSelectAllText: "Unselect All",
      searchPlaceholderText: "Type here to search",
      noDataLabel: 'No data available. It seems you have no access rights',
      closeDropDownOnSelection:true,
		} 
  }
  
  getUserDetail() {
    this.api.showLoader = false;
    this.api.loader(false)
    this.api.getDatas(apiUrl._getUserInfo)
      .subscribe(async (res) => {
        this.userData = res.data;
        this.haveFileName = this.userData.authenticityDocumentLink,
          this.fileName = this.userData.authenticityDocumentLink,
          this.haveVeternFileName = this.userData.veteranRelationDocumentLink,
          this.vetFileName = this.userData.veteranRelationDocumentLink,
          this.form.patchValue({
            ...this.userData,
            authenticityDocumentLink: this.userData.authenticityDocumentLink,
            veteranRelationDocumentLink: this.userData.veteranRelationDocumentLink,
            // JobTitle: this.userData.militaryJobTitle,
            serviceDisabled: this.userData.serviceDisabled
          })
console.log(this.userData)

      })
  }
  getServices() {
    this.api.showLoader = false;
    this.api.loader(false)
    this.api.getDatas(apiUrl._commonServices)
      .subscribe(async (res) => {
        this.serviceList = res.data.listing;
      }, err => {
        this.toastrService.error("Error", err.error.message)
      })
  }

  selectedService(event) {
    this.selectedServiceId = event;
    this.serviceList.map((uni) => {
      if (event == uni.id && uni.name == "Other") {
        this.showOtherService = true;
      } else { 
        this.showOtherService = false;
      }
    })
    this.form.patchValue({JobTitle:''})
    this.getMosCode()
  }
  
// getMosCode
getMosCode(){
  this.api.stopLoader();  
  let params = new HttpParams(); 
  params = params.append("serviceId", this.selectedServiceId); 
  this.api.getData(apiUrl._getMosListing,params)
  .subscribe(async (res) => {
    res.data.map((mos) => {
      mos["fullName"] = "(" + mos.mos + ") " + mos.name  + " - " + mos.rank
      if (this.userData && this.userData?.militaryJobTitle == mos.fullName) {
        this.form.patchValue({
          JobTitle: [{fullName: mos["fullName"], name: mos["id"]}]
        })
      }
    })

    this.allMosCode = res.data;
   })
}
// upload
  upload(event) {
    if (event.target.files[0].size > 500000) {
      this.fileSize = true
      setTimeout(() => {
        this.fileSize = false
      }, 2000);
      return
    }
    if (event.target.files[0].type.includes("image") && (event.target.files[0].name.split(".")[1] != "png" && event.target.files[0].name.split(".")[1] != "svg") || event.target.files[0].type.includes("pdf")) {
      const files = event.target.files;
      this.fileUpload = files[0];
      this.haveFileName = this.fileUpload.name
      this.uploadFileToS3();
    } else {
      this.showError = true
      setTimeout(() => {
        this.showError = false
      }, 2000);
      this.api.showErrorUpload("", "Please upload only Jpg,Jpeg images & Pdf file")
    }

  }
  uploadVeteranDoc(event) {
    if (event.target.files[0].size > 500000) {
      this.fileSizeVeteranRelation = true
      setTimeout(() => {
        this.fileSizeVeteranRelation = false
      }, 2000);
      return
    }
    if (event.target.files[0].type.includes("image") && (event.target.files[0].name.split(".")[1] != "png" && event.target.files[0].name.split(".")[1] != "svg") || event.target.files[0].type.includes("pdf")) {
      const files = event.target.files;
      this.vetFileUpload = files[0];
      this.haveVeternFileName = this.vetFileUpload.name
      this.uploadVeternFileToS3();
    } else {
      this.showError = true
      setTimeout(() => {
        this.showError = false
      }, 2000);
      this.api.showErrorUpload("", "Please upload only Jpg,Jpeg images & Pdf file")
    }

  }

  uploadFileToS3() {
    this.loading = true;
    const data = {
      "directory": "users/",
      "fileName": this.fileUpload.name,
      "contentType": this.fileUpload.type
    }
    this.fileName = data.fileName;
    
    this.api.postData(apiUrl._upload, data)
      .subscribe(res => {
        this.http = new HttpClient(this.handler);
        this.http.put<any>(res.data.uploadURL, this.fileUpload).subscribe(response => {
          this.haveFileName = res.data.fileName
          this.form.value.authenticityDocumentLink = res.data.fileName
          this.form.patchValue({
            authenticityDocumentLink: res.data.fileName
          })
          this.loading = false;
        })
      })
  }
  uploadVeternFileToS3() {
    this.loading = true;
    const data = {
      "directory": this.globalUrl,
      "fileName": this.vetFileUpload.name,
      "contentType": this.vetFileUpload.type
    }
    this.vetFileName = data.fileName;
    this.api.postData(apiUrl._upload, data)
      .subscribe(res => {
        this.http = new HttpClient(this.handler);
        this.http.put<any>(res.data.uploadURL, this.vetFileUpload).subscribe(response => {
          this.haveVeternFileName = res.data.fileName
          this.form.value.veteranRelationDocumentLink = res.data.fileName
          this.form.patchValue({
            veteranRelationDocumentLink: res.data.fileName
          })
          this.loading = false;
        })
      })
  }
  changeAccept(event) {
    this.isAccept = event.target.checked
    if (event.target.checked == "1") {
      this.isAccept = true
    }
  }
  // add awards
  addMore(input, name) {
    if (name != null && name.trim() != "") {
      this.awardList.push({ name, orderByIndex: this.awardList.length + 1 });
      input.value = "";
    }
    this.form.patchValue({
      honorAwardArray: this.awardList
    })
  }
  deleteLanguage(name) {
    const index = this.awardList.indexOf(name);
    if (index >= 0) this.awardList.splice(index, 1);
  }

  onSubmit() {
    if (!this.haveFileName) {
      this.showError = true
      setTimeout(() => {
        this.showError = false
      }, 3000)
      return;
    }
    if (!this.haveVeternFileName && this.userData?.userType == 1 && this.veteranRelationName == 1) {
      this.showError = true
      setTimeout(() => {
        this.showError = false
      }, 3000)
      return;
    }
    if (this.showOtherService == true && this.form.value.otherServiceTitle == "") {
      this.showError = true;
      return
    } else {
      this.showError = false
    }
    if(this.form.value.JobTitle != ""){
      this.form.patchValue({
        militaryJobTitleId :this.form.value.JobTitle[0].id,
        militaryJobTitle :this.form.value.JobTitle[0].fullName

      })
    }
    this.form.patchValue({
      authenticityDocumentLink: this.haveFileName,
      veteranRelationDocumentLink: this.haveVeternFileName,
      honorAwardArray: this.awardList,
      userType: this.userData.userType,
    })
    if (this.form.valid) {
      delete this.form.value.JobTitle;
      if (this.form.value.honorAwardArray == "") {
        delete this.form.value.honorAwardArray;
      }
      if (this.form.value.isRequired == 0 || this.form.value.isRequired == false) {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 2000);
        return
      }  
      this.uploadDocument()
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 1000);
    }
  }
  uploadDocument() {
    this.loading = true;
    delete this.form.value.isRequired
    this.api.putData(apiUrl._updateAuthDocumentV1, this.removeEmptyFiled(this.form))
      .subscribe(async (res) => {
        this.loading = false
        this.router.navigate(["/complete-profile"]);
        this.toastrService.success("Documents uploaded successfully .");
      })
  }

  removeEmptyFiled(form) {
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }
}
